import { useState, useCallback, RefObject, ChangeEvent } from "react";
import logo from "assets/img/logo.png";
import { Input, Button, Form } from "antd";
import { StyledComponent } from "./style";
import { useDispatch, useSelector } from "react-redux";
import {
  checkPageActions,
  selectCheckPageLoading,
  selectCheckResult,
} from "./slice";
import { Loading } from "components/Loading";
import { useForm } from "antd/es/form/Form";
import { DoubleRightOutlined } from "@ant-design/icons";
import classNames from "classnames";

interface HeaderProps {
  containerRef: RefObject<HTMLDivElement>;
}

export default function Header({ containerRef }: HeaderProps) {
  const [form] = useForm();
  const dispatch = useDispatch();

  const loading = useSelector(selectCheckPageLoading);
  const result = useSelector(selectCheckResult);

  const [valueInput, setValueInput] = useState<string>("");
  const [isUserInsertText, setIsUserInsertText] = useState<boolean>(false);

  const handleChangeInputCheckPage = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.trim();
      setValueInput(value);
      setIsUserInsertText(false);
    },
    []
  );

  const handleScrollToGuide = () => {
    if (containerRef.current) {
      window.scrollTo({
        top: containerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  const onFinish = () => {
    dispatch(
      checkPageActions.checkingPageStarted({
        link: valueInput,
      })
    );
    setIsUserInsertText(true);
  };

  return (
    <StyledComponent>
      <div className="header">
        <div className="header-main">
          <div className="header-logo">
            <img className="header-logo-main" src={logo} alt="logo" />
            <p className="header-logo-desc">Bảo vệ khách hàng</p>
          </div>
          <div className="header-title">
            <p className="header-title-heading">YODY Xin chào!</p>
            YODY đang nhận được rất nhiều phản hồi từ khách hàng về các trang,
            nhóm Facebook giả mạo thương hiệu YODY để chiếm đoạt tài sản. Để
            YODY có thể bảo vệ quý khách, hãy kiểm tra các trang, nhóm chính
            thức của YODY tại đây.
          </div>
          <div className="header-search">
            <p className="header-search-title">NHẬP LINK ĐỂ KIỂM TRA</p>
            <p className="header-search-mobile-title">
              <p className="header-title-mobile-heading">YODY Xin chào! </p>
              BẠN NHẬP LINK ĐỂ KIỂM TRA XEM CÓ PHẢI PAGE CHÍNH HÃNG CỦA YODY
              KHÔNG?
            </p>
            <Form
              form={form}
              className="header-search-form"
              onFinish={onFinish}
            >
              <Form.Item
                className="header-search-form-item"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Vui lòng nhập link cần kiểm tra",
                  },
                  { max: 1000, message: "Link không được vượt quá 1000 ký tự" },
                ]}
              >
                <Input
                  allowClear
                  className="header-search-box-input"
                  placeholder="Nhập link facebook tại đây"
                  value={valueInput}
                  onChange={handleChangeInputCheckPage}
                />
              </Form.Item>
              <Button
                className="header-search-box-btn"
                type="primary"
                htmlType="submit"
              >
                Kiểm tra
              </Button>
            </Form>

            <div className="header-search-result">
              {loading && (
                <div className="header-search-result-checking">
                  <p className="header-search-result-checking-desc">
                    ĐANG KIỂM TRA
                  </p>
                  <Loading />
                </div>
              )}

              {isUserInsertText && result?.message && !loading && (
                <div
                  className={classNames(
                    result.type_check === "success" &&
                      "header-search-result-success",
                    result.type_check === "warning" &&
                      "header-search-result-wrong-format",
                    result.type_check === "failed" &&
                      "header-search-result-failed"
                  )}
                >
                  {result?.message}
                </div>
              )}
            </div>

            <Button
              className="guide-get-link-facebook"
              onClick={handleScrollToGuide}
            >
              <span>Hướng dẫn lấy link facebook</span>
              <DoubleRightOutlined style={{ transform: "rotate(90deg)" }} />
            </Button>
          </div>
        </div>
      </div>
    </StyledComponent>
  );
}
